<template>
    <div class="item" :class="{ clickable: clickable }" :style="itemStyles">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: 'ListItem',
        props: {
            height: {
                type: String,
                default: 'auto',
            },
            clickable: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            itemStyles() {
                return {
                    height: this.height,
                };
            },
        },
    };
</script>
<style lang="scss" scoped>
    .item {
        @include flex-split;
        height: 60px;
        position: relative;
        transition: border-color 0.2s, background-color 0.2s;
        padding: 0.15em 0.5em;
        border: 1px solid transparent;
        border-left: none;
        border-right: none;
        border-top-color: $color-border;

        &:last-child {
            border-bottom-color: $color-border;
        }

        &.clickable {
            cursor: pointer;

            &:hover {
                background: #f1f1f1;
            }
        }

        > div {
            height: 100%;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;

            &.split {
                justify-content: space-between;
            }
        }
    }
</style>
